import type { TutorialSlide } from '../screens/TutorialScreen'
import { NeonColors, FONTS, neonText } from '../neon-theme'
import { ControlsSlide } from './ControlsSlide'
import { EntryStakeSlide } from './EntryStakeSlide'
import { PortalSlide } from './PortalSlide'
import { MinimapSlide } from './MinimapSlide'
import { BotsSlide } from './BotsSlide'

function placeholderSlide(title: string, subtitle: string, emoji: string): TutorialSlide {
  let container: HTMLDivElement | null = null

  return {
    mount(el: HTMLDivElement, _onReady: () => void) {
      container = el

      const icon = document.createElement('div')
      icon.textContent = emoji
      icon.style.cssText = 'font-size: 64px; margin-bottom: 24px;'
      el.appendChild(icon)

      const h = document.createElement('h2')
      h.textContent = title
      h.style.cssText = `
        font-size: 1.4rem; margin: 0 0 12px;
        font-family: ${FONTS.title};
        letter-spacing: 0.15em;
        ${neonText(NeonColors.primary, NeonColors.primaryGlow)}
      `
      el.appendChild(h)

      const p = document.createElement('p')
      p.textContent = subtitle
      p.style.cssText = `
        font-size: 0.85rem; margin: 0;
        color: ${NeonColors.textMuted};
        font-family: ${FONTS.body};
        max-width: 280px;
        text-align: center;
        line-height: 1.5;
      `
      el.appendChild(p)
    },
    unmount() {
      if (container) container.innerHTML = ''
      container = null
    },
  }
}

export function createTutorialSlides(): { slides: TutorialSlide[]; durations: number[] } {
  const slides: TutorialSlide[] = [
    new ControlsSlide(),
    new EntryStakeSlide(),
    new PortalSlide(),
    new MinimapSlide(),
    new BotsSlide(),
  ]

  const durations = [
    10000,
    6000,
    8000,
    16000,
    10000,
  ]

  return { slides, durations }
}
